exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row:hover td[data-v-477683c3]{background-color:rgba(0,0,0,.05)}", ""]);

// exports
